import r from "react";
import "../../../../../../../Accordion/Accordion.js";
import "../../../../../../../AdCard/AdCard.js";
import "../../../../../../../AdCardImageCarousel/AdCardImageCarousel.js";
import "../../../../../../../AdMediaCounter/AdMediaCounter.js";
import "../../../../../../../Alertbox/Alertbox.js";
import "../../../../../../../Alertbox/Links.js";
import "../../../../../../../ArrowButton/ArrowButton.js";
import "../../../../../../../Autocomplete/Autocomplete.js";
import "../../../../../../../Autocomplete/AutocompleteListItem.js";
import { Avatar as c } from "../../../../../../../Avatar/Avatar.js";
import "../../../../../../../Badge/Badge.js";
import "../../../../../../../Breadcrumb/Breadcrumb.js";
import "../../../../../../../Button/Button.js";
import "../../../../../../../ButtonSocial/ButtonSocial.js";
import "../../../../../../../Card/Card.js";
import "../../../../../../../CardCoverImage/CardCoverImage.js";
import "../../../../../../../CardSuggestion/CardSuggestion.js";
import "../../../../../../../CardTopImage/CardTopImage.js";
import "../../../../../../../Carousel/Carousel.js";
import "../../../../../../../Carousel/components/CarouselNext.js";
import "../../../../../../../Carousel/components/CarouselPrevious.js";
import "../../../../../../../Carousel/components/CarouselContent.js";
import "../../../../../../../Carousel/components/CarouselItem.js";
import "embla-carousel-autoplay";
import "embla-carousel-react";
import "../../../../../../../Checkbox/Checkbox.js";
import "../../../../../../../Chip/Chip.js";
import "../../../../../../../Chips/Chips.js";
import "../../../../../../../Container/Container.js";
import "../../../../../../../Divider/Divider.js";
import "../../../../../../../Dropdown/Dropdown.js";
import { Flex as o } from "../../../../../../../Flex/Flex.js";
import "../../../../../../../FocusHeader/FocusHeader.js";
import "../../../../../../../Footer/Footer.js";
import "../../../../../../../FormControl/FormControl.js";
import "../../../../../../Header.js";
import "../../../../../../../HelpText/HelpText.js";
import "../../../../../../../IconAction/IconAction.js";
import "../../../../../../../ImageCarousel/ImageCarousel.js";
import "../../../../../../../InputChips/InputChips.js";
import "../../../../../../../LayoutContainer/LayoutContainer.js";
import { Link as s } from "../../../../../../../Link/Link.js";
import "../../../../../../../LogoCompraSegura/LogoCompraSegura.js";
import "../../../../../../../LogoOLX/LogoOLX.js";
import "../../../../../../../LogoOLXPay/LogoOLXPay.js";
import "../../../../../../../LogoOLXPayPlusDelivery/LogoOLXPayPlusDelivery.js";
import "../../../../../../../Lurker/Lurker.js";
import "../../../../../../../MediaCounter/MediaCounter.js";
import "../../../../../../../Modal/Modal.js";
import "../../../../../../../Multiselect/Multiselect.js";
import "../../../../../../../Navbar/Navbar.js";
import "../../../../../../../Overflow/Overflow.js";
import "../../../../../../../PriceReferenceRuler/PriceReferenceRuler.js";
import "../../../../../../../ProgressBar/ProgressBar.js";
import "../../../../../../../ProgressCircle/ProgressCircle.js";
import "../../../../../../../ProgressStepped/ProgressStepped.js";
import "../../../../../../../Radio/Radio.js";
import "../../../../../../../Skeleton/Skeleton.js";
import "../../../../../../../Slider/Slider.js";
import "../../../../../../../Slider/RangeSlider.js";
import "../../../../../../../Spinner/Spinner.js";
import "../../../../../../../Tabs/Tabs.js";
import "../../../../../../../Tabs/components/Tab/Tab.js";
import { Text as d } from "../../../../../../../Text/Text.js";
import "../../../../../../../TextArea/TextArea.js";
import "../../../../../../../TextInput/TextInput.js";
import "../../../../../../../Toast/Toast.js";
import "../../../../../../../ToggleSwitch/ToggleSwitch.js";
import "../../../../../../../Tooltip/Tooltip.js";
import "clsx";
import "@olxbr/ds-icons";
import { sendClickEvent as f } from "../../../../../../utils/sendClickEvent.js";
const x = _ref => {
  let {
    text: m,
    src: i,
    badge: p,
    alt: e,
    publicAccountId: a,
    tabIndex: l,
    trackingData: n
  } = _ref;
  const t = () => f("profile_page", "sub_menu", n);
  return r.createElement(o, {
    alignItems: "center",
    gap: "--spacing-2",
    padding: "--spacing-2",
    className: "olx-header__overflow-drawer-header"
  }, r.createElement(c, {
    alt: e,
    src: i,
    size: "40px"
  }), r.createElement(o, {
    flexDirection: "column",
    alignItems: "flex-start",
    className: "olx-header__overflow-drawer-header-text-container"
  }, r.createElement(d.BodySmall, {
    color: "--color-neutral-130"
  }, m), r.createElement(s, {
    href: "https://www.olx.com.br/perfil/".concat(a),
    onClick: t,
    onAuxClick: t,
    tabIndex: l
  }, "Meu perfil")), p);
};
export { x as DrawerHeader };